class LoadMorePagination extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.gridSelector = '.collection-grid';
    this.onLoadMore = this.handleLoadMore.bind(this);
  }

  connectedCallback() {
    if (this.dataset.nextUrl && this.button) {
      this.button.addEventListener('click', this.onLoadMore, true);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.onLoadMore, true);
    }
  }

  async handleLoadMore() {
    if (!this.dataset.nextUrl) return;

    // Optional: Add loading state to button
    const originalText = this.button.innerHTML;
    this.button.innerHTML = 'Loading...';
    this.button.disabled = true;

    try {
      const response = await fetch(this.dataset.nextUrl);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const htmlText = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(htmlText, 'text/html');

      // 1. Get new products
      const newGrid = newDocument.querySelector(this.gridSelector);
      const currentGrid = document.querySelector(this.gridSelector);

      if (newGrid && currentGrid) {
        // Append all new product nodes to current grid
        Array.from(newGrid.children).forEach(child => {
          currentGrid.appendChild(child);
        });
      }

      // 2. Update Viewing Text
      const viewingSelector = '.collection-footer__viewing';
      const newViewingText = newDocument.querySelector(viewingSelector);
      const currentViewingText = document.querySelector(viewingSelector);
      
      if (newViewingText && currentViewingText) {
        currentViewingText.innerHTML = newViewingText.innerHTML;
      }

      // 3. Update Pagination Component
      const newPagination = newDocument.querySelector('load-more-pagination');
      
      if (newPagination) {
        this.innerHTML = newPagination.innerHTML;
        this.dataset.nextUrl = newPagination.dataset.nextUrl;
        
        // Re-bind button events since innerHTML replaced the node
        this.button = this.querySelector('button');
        if (this.button) {
          this.button.addEventListener('click', this.onLoadMore, true);
        }
      } else {
        // No more pages, remove component entirely
        this.remove();
      }

    } catch (error) {
      console.error('Error loading more products:', error);
      this.button.innerHTML = originalText;
      this.button.disabled = false;
    }
  }
}

if (!customElements.get('load-more-pagination')) {
  customElements.define('load-more-pagination', LoadMorePagination);
}
